const BASKET_UPDATE_TYPES = {
  QUANTITY: 'QUANTITY',
  REMOVE: 'REMOVE',
};

export default BASKET_UPDATE_TYPES;
